import { ShortlistApi } from 'v5/api/shortlist/shortlist.api';
import { WithServices } from 'v5/platform/ts/services';
import { WithErrorService } from 'v5/services/front/ErrorService/ErrorService';
import { SystemEffect } from 'v5/services/internal/MessageService/_private/SystemEffectMessage';
import { WithMessageService } from '../../internal/MessageService/MessageService';
import { ShortlistMutationService } from './ShortlistMutationService';

export function createShortlistMutationService(
  config: WithServices<[WithMessageService, WithErrorService]> & {
    api: ShortlistApi;
  }
): ShortlistMutationService {
  const {
    api,
    services: { messageService, errorService }
  } = config;
  const interceptor = errorService.withCategory('ShortlistMutationService');

  async function reportEffectAndWaitUntilCacheReady(
    scope: SystemEffect[] = []
  ) {
    await messageService.reportSystemEffect.sendRequest(
      {
        scope
      },
      3000
    );
  }

  return {
    archiveShortlists: interceptor.wrap(async request => {
      try {
        await api.bulkArchive(request);

        // Report system effects for successfully archived shortlists
        await reportEffectAndWaitUntilCacheReady(
          request.ids.map(id => ({
            entity: 'shortlist',
            entityId: id,
            payload: { type: 'update' }
          }))
        );
      } catch (error) {
        console.error('Failed to archive shortlists:', error);
        throw new Error('Failed to archive shortlists');
      }
    }),

    unarchiveShortlists: interceptor.wrap(async request => {
      try {
        await api.bulkUnarchive(request);

        // Report system effects for successfully unarchived shortlists
        await reportEffectAndWaitUntilCacheReady(
          request.ids.map(id => ({
            entity: 'shortlist',
            entityId: id,
            payload: { type: 'update' }
          }))
        );
      } catch (error) {
        console.error('Failed to unarchive shortlists:', error);
        throw new Error('Failed to unarchive shortlists');
      }
    })
  };
}

